module.exports = __webpack_public_path__ + "static/removeProduct-5dabda7bb9494327b948442bc5067923.mp3";